/**
 * Created by Kristy on 24/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('purchasePresentItems', {
                parent: 'purchaseView',
                url: '/purchasePresentItems',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_PHARM_VISITOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_STOREHOUSE', 'ROLE_PHARM_SUPERVISOR']
                },
                templateUrl: 'app/displays/purchases/purchasePresentItems/purchasePresentItems.html',
                controller: 'PurchasePresentItemsController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('purchase');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
